export enum NotificationEvent {
  BROADCASTED = 'NotificationEvent:BROADCASTED',
  CLEARED = 'NotificationEvent:CLEARED',
  CLEARED_PARTIAL = 'NotificationEvent:CLEARED_PARTIAL',
  DELETED = 'NotificationEvent:DELETED'
}
